// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__ytq7l","bigColWidth":"Table_bigColWidth__yXWMf","biggerColWidth":"Table_biggerColWidth__f0b5p","row":"Table_row__3szhS","col":"Table_col__2a1PN"};